import logo from './logo.svg';
import './App.css';
import Container from './Container';
import SectionHeader from './SectionHeader';

function App() {
  return (
    <div className="App">
        <Container/>
    </div>
  );
}

export default App;
